<div class="align-items-start">
  <div class="tabs-container col col-12">
    <div class="row d-flex">
      <ng-content></ng-content>
      <app-tab
        *ngFor="let tab of tabs | keyvalue; index as idx; trackBy: getTabKey"
        (tabClick)="tabClick.emit($event)"
        [tabKey]="tab.key"
        [tabText]="tab.value"
        [isActive]="tab.key === activeTab"
        [isFirst]="idx === 0"
        [isLast]="idx === lastTabIndex"
      >
      </app-tab>
    </div>
  </div>
</div>
